import { FC, useEffect, useState } from 'react';
import { ColumnsType } from 'antd/lib/table';

import { IPOTable } from '../../../styles/components/IPOTable';
import { RenderTabelProjectWrap } from './style';
import React from 'react';
import { IGetMyProjectsProps } from '../member-page';
import { projectIsRemove } from '../utils';

type IRenderTabelDomProps = {
	title: string;
	key: string;
	dataSource?: IGetMyProjectsProps[];
	isCurrent: boolean,
	columns:ColumnsType<object>;
};

export const RenderTabelDom: FC<IRenderTabelDomProps> = ({ title, dataSource, isCurrent, columns }) => {
	const [list, setList] = useState<object[]>([]);
	useEffect(() => {
		if (dataSource) {
			let newList = dataSource.filter((item) => {
				if (isCurrent) {
					return (
						item.project.progressStatus !== 'FINISHED' &&
						!projectIsRemove(item.project.teamState as 0 | 1, item.project.teamMemberState as 0 | 1)
					);
				} else {
					return (
						item.project.progressStatus === 'FINISHED' ||
						projectIsRemove(item.project.teamState as 0 | 1, item.project.teamMemberState as 0 | 1)
					);
				}
			})
			setList(newList);
		}
	}, [dataSource])

	return (
		<RenderTabelProjectWrap>
			<div className="tit">{title}</div>
			<div className="table-list">
				<IPOTable rowKey="id" dataSource={list} columns={columns} pagination={false} />
			</div>
		</RenderTabelProjectWrap>
	);
};
